import React from "react";
import { Link } from "react-router-dom";
import FacebookLogo from "../assets/facebook-f-brands-solid 1.png";
import InstagramLogo from "../assets/instagram-brands-solid 2.png";
import LinkedInLogo from "../assets/linkedin-in-brands-solid 1.png";
import GMLogo from "../assets/logo-gm-blanc.png";

export default function Footer() {
    return (
        <footer>
            <div className="footer__container">
                <div className="footer__main">
                    <div className="footer__brand">
                        <div className="footer__logo">
                            <img src={GMLogo} alt="Groupe Michel" />
                        </div>
                        <p className="footer__tagline">Alpine Store La Rochelle</p>
                        <p className="footer__description">
                            Votre concessionnaire Alpine de référence à La Rochelle. 
                            Découvrez l'excellence automobile française dans un cadre exceptionnel.
                        </p>
                    </div>
                    
                    <div className="footer__links">
                        <div className="footer__section">
                            <h4>Services</h4>
                            <ul>
                                <li><a href="https://www.alpinecars.fr/contactez-nous/reservez-un-essai/book-a-test-drive/contact-details.html?modelAdminId=a290">Nous contacter</a></li>
                                <li><a href="https://www.alpinecars.fr/contactez-nous/reservez-un-essai/book-a-test-drive/contact-details.html?modelAdminId=a290">Essai</a></li>
                                <li><a href="https://www.alpinecars.fr/gamme/a110/configurer.html">Configuration</a></li>
                            </ul>
                        </div>
                        
                        <div className="footer__section">
                            <h4>Informations</h4>
                            <ul>
                                <li><Link to="/mentions-legales">Mentions Légales</Link></li>
                                <li><a href="https://www.alpinecars.fr/">Alpinecars.com</a></li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="footer__socials">
                        <h4>Réseaux sociaux</h4>
                        <div className="social__grid">
                            <a href="https://www.facebook.com/AlpineGroupeMichel/?locale=fr_FR">
                                <img src={FacebookLogo} alt="Facebook" />
                            </a>
                            <a href="https://www.instagram.com/alpine_larochelle/">
                                <img src={InstagramLogo} alt="Instagram" />
                            </a>
                            <a href="https://www.linkedin.com/showcase/alpine-store-la-rochelle/?originalSubdomain=fr">
                                <img src={LinkedInLogo} alt="LinkedIn" />
                            </a>
                        </div>
                    </div>
                </div>
                
                <div className="footer__bottom">
                    <div className="footer__copyright">
                        {new Date().getFullYear()} Alpine Store La Rochelle - Tous droits réservés
                    </div>
                    <div className="footer__gm-logo">
                        <img src={GMLogo} alt="Groupe Michel" />
                    </div>
                </div>
            </div>
        </footer>
    );
}
